import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthlyExpenseByMonthDatatable";
import {
  getSingleMonthlyRedux,
  clearSingleMonthRedux,
} from "../../../actions/index";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  getAllCashIns,
  getAllCashInsInvest,
} from "../../../firebase/firebase.utils";
import "./invest.css";

export class MonthlyExpenseByMonth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
      allExpenses: [],
    };
  }

  componentDidMount = async () => {
    let allCashIns = await getAllCashInsInvest(this.props.match.params.month);
    this.setState({
      allExpenses: allCashIns,
    });
  };

  componentWillUnmount = () => {
    this.props.clearSingleMonthRedux();
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };

  render() {
    const { open } = this.state;

    let totalInvest = 0;
    this.state.allExpenses.map((expense) => {
      totalInvest += parseInt(expense.amount);
    });
    console.log(this.props);
    return (
      <Fragment>
        <Breadcrumb title="InvestMent" parent="Monthly expense" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid iv-page">
          <div className="row">
            <div className="col-sm-12">
              <div className="card iv-card">
                <div className="card-header iv-card-header">
                  <h5 className="iv-card-title">
                    <i className="icofont-calendar iv-card-icon"></i>
                    {this.props.match.params.month}
                  </h5>
                </div>
                <div className="card-body">
                  <div className="iv-total-chip">
                    <span className="iv-total-chip-label iv-stamp-font">Total Investment</span>
                    <span className="iv-total-chip-value">{totalInvest}Tk</span>
                  </div>
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      history={this.props.history}
                      multiSelectOption={false}
                      myData={this.state.allExpenses}
                      pageSize={50}
                      pagination={true}
                      class="-striped -highlight"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allExpenses: state.expenses.singleMonth,
  };
};

export default connect(mapStateToProps, {
  getSingleMonthlyRedux,
  clearSingleMonthRedux,
})(MonthlyExpenseByMonth);
